<!--  Capacity  -->
<template>
  <div class="apply-capacity">
    <div class="apply-capacity-intro">
      <div class="intro-item">
        <h1>Basic Responsibilities</h1>
        <div>
          Help mentees with graduate study applications and career guidance in your field<br />
          Help with application essays (focusing on strategy, content and style) as well as give mentees advice on graduate study, careers etc. through video conference<br />
          The busiest time of year for School Mentor/ Career Mentor is generally around graduate application season (Sep-Feb), however work may be available throughout the year.
        </div>
      </div>
      <div class="intro-item">
        <h1>Benefits</h1>
        <div>
          Get remunerated up to US$90/hr for helping a bright young person<br />
          Join our Mentor Network of talented individuals across industries (we already have 50+ Rhodes Scholars in our community)<br />
          Receive exclusive job opportunities as part of our Mentor Network (past include executive assistant roles for CEOs, roles at UNDP, roles with the Schwarzman Scholar program, etc.)
        </div>
      </div>
      <div class="intro-item">
        <h1>Requirements</h1>
        <div>
          Previously studied at or currently completing top graduate program/university<br />
          Positive and interested in positively impacting a bright young person at a critical juncture<br />
          Reliable and responsible in honoring commitments
        </div>
      </div>
    </div>
    <div class="apply-capacity-con">
      <div>
        <h1>Capacity</h1>
        <p>Please indicate the number of mentees you are able to take on. On average, each mentee requires 1-2 hrs/week. Please estimate the maximum number of mentees you would like to take on in the next application season. For example, 2021 means the mentee is applying for 2021 fall enrollment, therefore you will help the mentees mostly in 2020 fall.</p>
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate">
          <div class="apply-capacity-select-360">
            <FormItem :label="formValidate.capacityInfos[0].index"
                        prop="capacityInfos[0].value">
              <Cascader :data="menteeNumList"
                        v-model="formValidate.capacityInfos[0].value"></Cascader>
            </FormItem>
          </div>
          <div class='apply-capacity-warn'>
            <a href='javascript: void(0);'
               @click="goEditMore">Please edit the multiple capacities of the following years according to your expected workload of the specific years if you like. </a>
          </div>
          <div class="apply-capacity-btn">
            <Button class="zlr-btn-primary"
                    @click="nextHandle"
                    :loading="isSub">Next</Button>
            <Button class="zlr-btn-default"
                    @click="backHandle">Back</Button>
          </div>
        </Form>
      </div>
    </div>
    <!--Capacity 详细表单-->
    <applySelectModal :value='editMoreModal'>
      <div name='slot'>
        <h1>Capacity</h1>
        <p>How many mentees would you like to take on？</p>
        <Form
              :model="formValidate"
              class='apply-capacity-modal'>
              <div class="apply-capacity-select" v-for="item in formValidate.capacityInfos" :key="item.index">
                <FormItem :label="item.index">
                  <Cascader :data="menteeNumList"
                        v-model="item.value"></Cascader>
            </FormItem>
          </div>
          <!-- <div class="apply-capacity-select">
            <FormItem label="2020"
                      prop="capacityInfos[0]">
              <Cascader :data="menteeNumList"
                        v-model="formValidateMore.capacityInfos[0]"></Cascader>
            </FormItem>
          </div>
          <div class="apply-capacity-select">
            <FormItem label="2021"
                      prop="capacityInfos[1]">
              <Cascader :data="menteeNumList"
                        v-model="formValidateMore.capacityInfos[1]"></Cascader>
            </FormItem>
          </div>
          <div class="apply-capacity-select">
            <FormItem label="2022"
                      prop="capacityInfos[2]">
              <Cascader :data="menteeNumList"
                        v-model="formValidateMore.capacityInfos[2]"></Cascader>
            </FormItem>
          </div>
          <div class="apply-capacity-select">
            <FormItem label="2023"
                      prop="capacityInfos[3]">
              <Cascader :data="menteeNumList"
                        v-model="formValidateMore.capacityInfos[3]"></Cascader>
            </FormItem>
          </div>
          <div class="apply-capacity-select">
            <FormItem label="2024"
                      prop="capacityInfos[4]">
              <Cascader :data="menteeNumList"
                        v-model="formValidateMore.capacityInfos[4]"></Cascader>
            </FormItem>
          </div> -->
          <div class="apply-capacity-btn">
            <Button class="zlr-btn-primary"
                    @click="subHandle">Submit</Button>
            <Button class="zlr-btn-default"
                    @click="closeHandle">Close</Button>
          </div>
        </Form>
      </div>
    </applySelectModal>
  </div>
</template>

<script>
// api
import { applyMentorCapacity } from '@/api/apply'
import { promptSelect } from '@/constant'
import applySelectModal from '../../../components/modal/modal'
import { capacityList } from '@/constant'
import dayjs from 'dayjs'
// mixins
import back from './back'
export default {
  name: 'apply-sm-capacity',
  mixins: [back],
  components: {
    applySelectModal
  },
  props: {
    value: {
      default: ''
    }
  },
  data () {
    return {
      formValidate: {
        capacityInfos: []
      },
      ruleValidate: {
        'capacityInfos[0].value': [{ required: true, message: promptSelect }]
      },
      isSub: false,
      menteeNumList: capacityList,
      // edit more 弹窗标识
      editMoreModal: false,
      // formValidateMore: {
      //   capacityInfos: [[], [], [], [], []]
      // },
      // ruleValidateMore: {}
    }
  },
  computed: {},
  created () { 
    const currentYear = dayjs().format('YYYY') + ''
    for (let i = 0; i < 3; i++)
    {
      this.formValidate.capacityInfos.push({
        value: [],
        index: (parseInt(currentYear)+i)+''
      })
    }
  },
  methods: {
    // Capacity Edit more
    goEditMore () {
      this.editMoreModal = true
      // this.formValidateMore.capacityInfos[1] = this.formValidate.capacityInfos[0]
    },
    // Capacity Edit more Submit
    subHandle () {
      // this.formValidate.capacityInfos[0] = this.formValidateMore.capacityInfos[1]
      // this.$refs.formValidateMore.resetFields()
      this.editMoreModal = false
    },
    // Capacity Edit more Close
    closeHandle () {
      // 重置弹窗
      this.formValidate.capacityInfos.forEach(res => { 
        res.value = []
      })
      this.editMoreModal = false
    },
    // 提交信息
    nextHandle () {
      // this.formValidateMore.capacityInfos[1] = this.formValidate.capacityInfos[0]
      this.$refs.formValidate.validate((valid) => {
        if (valid)
        {
          let yearArr = JSON.parse(JSON.stringify(this.formValidate.capacityInfos))
          let capacityInfos = []
          yearArr.forEach((item, index) => {
            if (item.value.length) {
              capacityInfos.push({
                year: item.index,
                count: +item.value.at(-1)
              })
            }
          })
          let data = {
            applyType: 'SMCM',
            capacityInfos
          }
          this.isSub = true
          applyMentorCapacity(data).then(res => {
            this.$emit('input', res.data.applyId)
            this.$emit('on-success')
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
